import React from 'react'
import ContentBrandHero from '../../../components/ContentBrandHero'

const HeroWidget = ({
  title,
  text,
  heroImages,
  backgroundImages,
  darkBackground
}) => (
  <ContentBrandHero
    title={title}
    summary={text}
    bg={
      backgroundImages &&
      backgroundImages.widgets &&
      backgroundImages.widgets[0] &&
      backgroundImages.widgets[0].crops &&
      backgroundImages.widgets[0].crops[0] &&
      backgroundImages.widgets[0].crops[0].src
    }
    img={
      heroImages &&
      heroImages.widgets &&
      heroImages.widgets[0] &&
      heroImages.widgets[0].crops &&
      heroImages.widgets[0].crops[0] &&
      heroImages.widgets[0].crops[0].src
    }
    dark={darkBackground}
  />
)

export default HeroWidget
